import styles from "./info-pages.module.css";
import { useEffect } from "react";

export const CookiesPage = () => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={styles.header}>
          <h1>Cookie Policy</h1>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>Last updated: 24th May 2025</h2>
          </div>
          <div className={styles.sectionContent}>
            <p>
              We are committed to protecting your privacy and ensuring
              transparency about how and why cookies are used on our website.
            </p>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>What Are Cookies?</h2>
          </div>
          <div className={styles.sectionContent}>
            <p>
              Cookies are small text files stored on your device when you visit
              a website. They help websites function correctly and can also be
              used to collect information about your browsing behavior.
            </p>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>What Cookies Do We Use?</h2>
          </div>
          <div className={styles.sectionContent}>
            <p>
              We aim to minimize the use of cookies. Currently, we only use
              cookies that are required for secure payment processing.
            </p>
            <h3>1. Stripe (Payment Provider)</h3>
            <p>
              When you proceed to checkout, we use{" "}
              <a
                href="https://stripe.com/gb"
                target="_blank"
                rel="noopener noreferrer"
              >
                Stripe
              </a>{" "}
              to securely handle your payment. Stripe sets the following cookies
              to prevent fraud and ensure a secure transaction:
            </p>
            <table className={styles.cookieTable}>
              <thead>
                <tr>
                  <th>Cookie Name</th>
                  <th>Purpose</th>
                  <th>Duration</th>
                  <th>Type</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <code>__stripe_sid</code>
                  </td>
                  <td>Session management</td>
                  <td>30 minutes</td>
                  <td>Non-essential</td>
                </tr>
                <tr>
                  <td>
                    <code>__stripe_mid</code>
                  </td>
                  <td>Fraud prevention/device ID</td>
                  <td>1 year</td>
                  <td>Non-essential</td>
                </tr>
              </tbody>
            </table>
            <p>
              <em>
                These cookies are set only when you choose to start a checkout
                process.
              </em>
            </p>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>Can You Opt Out?</h2>
          </div>
          <div className={styles.sectionContent}>
            <p>
              You can choose to reject cookies using the banner displayed when
              you first visit our site.
            </p>
            <p>
              <strong>However, please note:</strong>
              <br />
              If you reject cookies, you will not be able to use the checkout
              feature on our site, as Stripe cookies are required for payment
              security.
            </p>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>Managing Cookies</h2>
          </div>
          <div className={styles.sectionContent}>
            <p>
              You can also control or delete cookies through your browser
              settings:
            </p>
            <ul className={styles.unorderedList}>
              <li>
                Chrome:{" "}
                <a
                  href="https://support.google.com/chrome/answer/95647"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Settings &gt; Privacy and security &gt; Cookies
                </a>
              </li>
              <li>
                Firefox:{" "}
                <a
                  href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Settings &gt; Privacy & Security
                </a>
              </li>
              <li>
                Safari:{" "}
                <a
                  href="https://support.apple.com/en-gb/guide/safari/sfri11471/mac"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Settings &gt; Privacy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>Changes to This Policy</h2>
          </div>
          <div className={styles.sectionContent}>
            <p>
              We may update this Cookie Policy to reflect changes to the cookies
              we use or legal requirements. Please check back regularly for
              updates.
            </p>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>Contact</h2>
          </div>
          <div className={styles.sectionContent}>
            <p>
              If you have any questions about this Cookie Policy or how we use
              cookies, feel free to contact us at:
            </p>
            <p>
              <strong>Email:</strong> support@trailart.store
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
